/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：391
 */

"use strict"

function r(e) {
  return e && e.ownerDocument || document
}
export { r as a }
export default r
